export default __webpack_public_path__ + "static/media/Vector.636dc1d0.svg";